import { Controller } from "@hotwired/stimulus"
import * as CookieConsent from "vanilla-cookieconsent"

// Гарантируем однократную инициализацию при Turbo-навигациях
let initialized = false

export default class extends Controller {
  static values = {
    privacyUrl: String,
    cookiesUrl: String
  }

  connect() {
    if (initialized) return
    initialized = true

    const privacyUrl = this.hasPrivacyUrlValue ? this.privacyUrlValue : "/legal/privacy"
    const cookiesUrl = this.hasCookiesUrlValue ? this.cookiesUrlValue : "/legal/personal-data"

    CookieConsent.run({
      mode: "opt-out",
      autoShow: true,
      hideFromBots: true,
      cookie: {
        name: "cc_cookie",
        expiresAfterDays: 365,
        sameSite: "Lax"
      },

      guiOptions: {
        consentModal: {
          layout: "bar inline",
          position: "bottom",
          flipButtons: false,
          equalWeightButtons: false
        },
        preferencesModal: {
          layout: "box",
          flipButtons: false,
          equalWeightButtons: false
        }
      },

      categories: {
        necessary: {
          enabled: true,
          readOnly: true
        },
        analytics: {
          enabled: true,
          autoClear: {
            cookies: [
              { name: /^_ym/ },
              { name: "yandexuid" },
              { name: "yuidss" },
              { name: "ymex" },
              { name: "yashr" }
            ],
            reloadPage: false
          }
        }
      },

      language: {
        default: "ru",
        translations: {
          ru: {
            consentModal: {
              title: "Мы используем файлы cookie",
              description: `Мы используем необходимые cookie для работы сайта и аналитические cookie (Яндекс.Метрика) для улучшения сервиса. Продолжая пользоваться сайтом, вы соглашаетесь с <a href="${cookiesUrl}" target="_blank" rel="noopener noreferrer">политикой обработки персональных данных</a>.`,
              acceptAllBtn: "Принять все",
              acceptNecessaryBtn: "Только необходимые",
              showPreferencesBtn: "Настройки cookie",
              footer: `<a href="${privacyUrl}" target="_blank" rel="noopener noreferrer">Политика конфиденциальности</a>`,
            },
            preferencesModal: {
              title: "Настройки файлов cookie",
              acceptAllBtn: "Принять все",
              acceptNecessaryBtn: "Только необходимые",
              savePreferencesBtn: "Сохранить настройки",
              closeIconLabel: "Закрыть",
              sections: [
                {
                  title: "Использование cookie",
                  description:
                    "Мы используем файлы cookie в соответствии с требованиями Федерального закона №152-ФЗ «О персональных данных». Ниже вы можете выбрать, какие cookie вы разрешаете использовать."
                },
                {
                  title: "Необходимые cookie",
                  description:
                    "Эти файлы cookie необходимы для корректной работы сайта: аутентификация, безопасность (CSRF-защита), пользовательская сессия. Их нельзя отключить.",
                  linkedCategory: "necessary",
                  cookieTable: {
                    headers: {
                      name: "Cookie",
                      description: "Назначение",
                      duration: "Срок хранения"
                    },
                    body: [
                      {
                        name: "_session_id",
                        description: "Сессия пользователя (аутентификация)",
                        duration: "До закрытия браузера"
                      },
                      {
                        name: "authenticity_token",
                        description: "Защита от CSRF-атак",
                        duration: "До закрытия браузера"
                      },
                      {
                        name: "remember_user_token",
                        description: "Функция «запомнить меня»",
                        duration: "14 дней"
                      }
                    ]
                  }
                },
                {
                  title: "Аналитические cookie",
                  description:
                    "Помогают нам понять, как пользователи взаимодействуют с сайтом. Используется Яндекс.Метрика. Все данные собираются анонимно.",
                  linkedCategory: "analytics",
                  cookieTable: {
                    headers: {
                      name: "Cookie",
                      description: "Назначение",
                      duration: "Срок хранения"
                    },
                    body: [
                      {
                        name: "_ym_uid",
                        description: "Идентификатор посетителя Яндекс.Метрики",
                        duration: "1 год"
                      },
                      {
                        name: "_ym_d",
                        description: "Дата первого визита (Яндекс.Метрика)",
                        duration: "1 год"
                      },
                      {
                        name: "_ym_isad",
                        description:
                          "Определение наличия блокировщика рекламы",
                        duration: "2 дня"
                      },
                      {
                        name: "_ym_visorc",
                        description: "Запись сеансов Вебвизора (Яндекс.Метрика)",
                        duration: "30 минут"
                      }
                    ]
                  }
                }
              ]
            }
          }
        }
      }
    })
  }
}
